import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1290,1083.396 C1175.88,1196.556 1036.32,1353.276 957.96,1550.196 C881.04,1351.116 742.8,1195.356 630,1083.276 C488.64,943.236 420,803.796 420,656.796 C420,360.876 660.84,120.036 963.12,120.036 C1259.16,120.036 1500,360.876 1500,656.796 C1500,803.796 1431.36,943.236 1290,1083.396 M956.88,0.036 C594.72,0.036 300,294.636 300,656.796 C300,837.396 380.28,1004.796 545.4,1168.476 C785.16,1406.316 896.88,1626.036 896.88,1860.036 L896.88,1920.036 L1016.88,1920.036 L1016.88,1860.036 C1016.88,1627.116 1127.28,1413.876 1374.6,1168.596 C1539.72,1004.796 1620,837.396 1620,656.796 C1620,294.636 1325.28,0.036 956.88,0.036",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMarkerLine = /*#__PURE__*/function (_Component) {
  _inherits(IconMarkerLine, _Component);

  var _super = _createSuper(IconMarkerLine);

  function IconMarkerLine() {
    _classCallCheck(this, IconMarkerLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconMarkerLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMarker",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMarkerLine.displayName = "IconMarkerLine";
  return IconMarkerLine;
}(Component);

IconMarkerLine.glyphName = 'marker';
IconMarkerLine.variant = 'Line';
IconMarkerLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMarkerLine;
export { IconMarkerLine };